module.exports = __webpack_public_path__ + "img/adalides.fe119799.jpg";